import React from 'react';

import cx from 'classnames';
import { times } from 'lodash';
import PropTypes from 'prop-types';

import styles from './Skeleton.module.scss';

const Skeleton = ({ type, width, height, lines = 1, style, className }) => {
	const Shape = {
		CIRCLE: 'circle',
		TEXT: 'text',
		RECTANGLE: 'rectangle',
	};

	const styleObj =
		type == 'TEXT'
			? { borderRadius: `${(parseInt(height) * 50) / 100}px` }
			: {};

	return (
		<>
			{times(lines, (index) => {
				return (
					<span
						key={index}
						className={cx(styles.shine, styles[Shape[type]], className)}
						style={{
							width,
							height,
							...styleObj,
							...style,
						}}
					></span>
				);
			})}
		</>
	);
};

Skeleton.propTypes = {
	type: PropTypes.oneOf(['TEXT', 'CIRCLE', 'RECTANGLE']),
	width: PropTypes.string,
	height: PropTypes.string,
	lines: PropTypes.number,
	style: PropTypes.object,
	className: PropTypes.string,
};
Skeleton.defaultProps = {
	type: 'RECTANGLE',
	width: '',
	height: '',
	lines: 1,
	style: {},
	className: '',
};

export default Skeleton;
